module.exports = __webpack_public_path__ + "static/logo_huevocartoon-1fe09ef4632be07abd2f9fd445f78695.png";